<template>
  <div>
    <template v-if="filtered.length">
      <div class="green lighten-5 px-4 py-2">
        <div class="black--text caption">difilter berdasar:</div>
        <template v-for="(item, i) in filtered">
          <template v-if="$isObject(item)">
            <v-chip :key="i" @click:close="onDelete(item)" class="black--text mr-1" close small>
              {{ item && $isObject(item) ? item.text : item }}
            </v-chip>
          </template>
          <template v-else>
            <v-chip :key="i" class="mr-1" small>
              {{ item && $isObject(item) ? item.text : item }}
            </v-chip>
          </template>
        </template>
      </div>
      <v-divider></v-divider>
    </template>
    <v-dialog max-width="750px" scrollable v-model="dialog">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon class="mr-3 white--text">mdi-filter-variant</v-icon>
          <slot name="title">{{ title }}</slot>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text :class="compact ? 'py-6' : 'py-2'" :style="{ height: compact ? 'auto' : '300px' }">
          <v-row>
            <v-col :key="i" class="pr-3" v-bind="filter.grid" v-for="(filter, i) in filters">
              <v-list class="py-0" dense>
                <template v-if="filter.type === 'checkbox'">
                  <v-list-item :key="key" v-for="(item, key) in filter.master">
                    <v-list-item-action class="mt-2 pt-1" style="min-width: 35px">
                      <v-checkbox :value="item.value" v-model="params[filter.model]"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="body-2" v-html="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-else-if="filter.type === 'radio'">
                  <v-radio-group :row="filter.row" class="mt-0" hide-details v-model="params[filter.model]">
                    <template v-for="(item, key) in filter.master">
                      <v-radio :key="key" :value="item.value">
                        <template v-slot:label>
                          <div v-html="item.text"></div>
                        </template>
                      </v-radio>
                    </template>
                  </v-radio-group>
                </template>
                <template v-else-if="filter.type === 'text'">
                  <v-text-field
                    :label="filter.label"
                    dense
                    outlined
                    clearable
                    v-model="params[filter.model]"
                  ></v-text-field>
                </template>
                <template v-else-if="filter.type === 'date'">
                  <date-picker
                    :dense="filter.dense"
                    :label="filter.label"
                    :outlined="filter.outlined"
                    v-model="params[filter.model]"
                  ></date-picker>
                </template>
                <template v-else-if="filter.type === 'select'">
                  <div v-if="filter.master.length">
                    <div v-if="filter.default">
                      <v-select
                        :chips="filter.props.indexOf('chips') > -1"
                        :disabled="filter.disabled"
                        :items="filter.master"
                        :label="filter.label || ''"
                        :multiple="filter.props.indexOf('multiple') > -1"
                        :small-chips="filter.props.indexOf('small-chips') > -1"
                        dense
                        outlined
                        single-line
                        v-model="params[filter.model]"
                      ></v-select>
                    </div>
                    <div v-else>
                      <v-autocomplete
                        :disabled="filter.disabled"
                        :items="filter.master"
                        :label="`Pilihan ${filter.label || ''}`"
                        no-data-text="-"
                        v-model="params[filter.model]"
                      ></v-autocomplete>
                    </div>
                  </div>
                </template>
                <template v-else-if="filter.type === 'cascade'">
                  <base-cascade
                    :configs="filter.configs"
                    :labelColor="filter.labelColor"
                    class="ml-3 mr-3"
                    ref="cascade"
                    v-model="params"
                  >
                  </base-cascade>
                </template>
                <template v-else-if="filter.type === 'components'">
                  <base-render :params="params" :ref="filter.ref" :renderEl="onRender(filter.components)"></base-render>
                </template>
              </v-list>
            </v-col>
            <slot name="content" />
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="grey lighten-4 pa-3">
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text> Batal </v-btn>
          <v-btn @click.native="custReset()" color="warning darken-1" text> Setel Ulang </v-btn>
          <v-btn @click.native="save" color="primary">Terapkan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    closeable: {
      type: Boolean,
      default: false,
    },
    paramsFilter: {
      type: Object,
      default: () => {},
    },
    filters: {
      type: Array,
    },
    filtered: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      params: {},
      dialog: false,
      cache: {},
    };
  },
  methods: {
    open(data = {}) {
      this.cache = data;
      this.reset(data);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    custReset() {
      this.params = {};
      this.$emit('reset');
    },

    reset(value) {
      // set params
      if (value) {
        for (let i = 0; i < this.filters.length; i++) {
          const cascade = this.$getDeepObj(this.filters[i], 'configs.selector') || [];
          if (cascade.length) {
            for (let j = 0; j < cascade.length; j++) {
              const isDisabled = this.filters[i].disabled;
              let key = cascade[j];
              let init = ((value && value[key]) || (isDisabled ? this.cache && this.cache[key] : '') || '').toString();
              // set
              this.$set(this.params, key, init);
            }
          } else if (this.filters[i].type === 'components') {
            const isDisabled = this.filters[i].disabled;
            const name = this.filters[i] && this.filters[i].ref;
            const data = Object.assign(
              {},
              (value && value[name]) || (isDisabled ? this.cache && this.cache[name] : {}) || {}
            );
            if (this.$refs && this.$refs[name]) this.$refs[name][0].$refs.myComp.setSelected(data || {});
          } else {
            const isDisabled = this.filters[i].disabled;
            let key = this.filters[i].model;
            let init =
              this.filters[i].type === 'select'
                ? !Array.isArray(value && value[key])
                  ? (value && value[key]) || (isDisabled ? this.cache && this.cache[key] : '') || ''
                  : (value && value[key]) || (isDisabled ? this.cache && this.cache[key] : []) || []
                : ['date', 'text'].includes(this.filters[i].type)
                ? (value && value[key]) || (isDisabled ? this.cache && this.cache[key] : '') || ''
                : (value && value[key]) || (isDisabled ? this.cache && this.cache[key] : []) || [];

            // set
            this.$set(this.params, key, init);
          }
        }
      } else {
        this.params = {};
      }
    },

    onDelete(item) {
      let params = Object.assign({}, this.paramsFilter);

      // cek filter key adalah object, jika ya hapus value
      if (params[item.key] && typeof params[item.key] === 'object') {
        const index = params[item.key].indexOf(item.value);
        params[item.key].splice(index, 1);
      } else {
        delete params[item.key];
      }

      this.$emit('save', params);
    },

    save() {
      // get data from component
      const filters = this.filters.filter((item) => item.type === 'components');
      const params = {};
      if (filters.length)
        for (let i = 0; i < filters.length; i++) {
          const name = filters[i] && filters[i].ref;
          params[name] = this.$refs[name][0].$refs.myComp.getSelected();
        }

      // add param from this params
      const tempParams = Object.assign({}, this.params);
      for (const key in tempParams) {
        if (!tempParams[key]) delete tempParams[key];
      }

      this.$emit('save', Object.assign({}, tempParams, params));
    },

    onRender(components) {
      return (h) => {
        return h(components, {
          ref: 'myComp',
        });
      };
    },
  },
};
</script>
